var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeaderLabel',{attrs:{"title":"受講中のレッスン"}})}
var staticRenderFns = []

export { render, staticRenderFns }